import React from "react";
import styles from "./PageIcon.module.scss";
export function PageNext(props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: "7",
    height: "10",
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33398 9L5.33398 5L1.33398 1",
    className: props.isEnabled ? styles.enabled : styles.disabled
    // stroke={props.isEnabled ? "#12192B" : "#ACAEB5"}
    ,
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}